import {
    SET_ADDRESS_DATA_MUTATION,
    SET_PERSONAL_DATA_MUTATION,
    SET_SHIPMENT_DATA_MUTATION,
    SET_ORDER_DATA_MUTATION,
    SET_ORDER_LOADING_TO_FALSE_MUTATION,
    SET_ORDER_LOADING_TO_TRUE_MUTATION,
    SET_PAYLANDS_PARAMS_MUTATION,
    SET_PAYMENT_METHOD,
    SET_BITCOIN_PARAMS,
    SET_CARDS,
    SET_SELECTED_CARD_UUID,
    SET_REGIONS,
    SET_SHIPPING_TYPE
} from "./types";

const wizardMutations = {
    [SET_ADDRESS_DATA_MUTATION](state, payload) {
        state.addressData = { ...payload };
    },
    [SET_PERSONAL_DATA_MUTATION](state, payload) {
        state.personalData = { ...payload };
    },
    [SET_SHIPMENT_DATA_MUTATION](state, payload) {
        state.shippingData = payload;
    },
    [SET_ORDER_DATA_MUTATION](state, payload) {
        state.order = {...payload};
    },
    [SET_ORDER_LOADING_TO_FALSE_MUTATION](state) {
        state.orderLoading = false;
    },
    [SET_ORDER_LOADING_TO_TRUE_MUTATION](state) {
        state.orderLoading = true;
    },
    [SET_PAYLANDS_PARAMS_MUTATION](state, payload){
        state.paylandsParams = {...payload}
    },
    [SET_PAYMENT_METHOD](state, payload){
        state.paymentMethod = payload;
    },
    [SET_BITCOIN_PARAMS](state, payload){
        state.bitcoinParams = payload;
    },
    [SET_CARDS](state, payload){
        state.cards = payload;
    },
    [SET_SELECTED_CARD_UUID](state, payload){
        state.selectedCardUUID = payload;
    },
    [SET_SHIPPING_TYPE](state, payload){
        state.shippingType = {...payload}
    },
    [SET_REGIONS](state, payload){
        state.regions = [...payload]
    }
};

export default wizardMutations;
